const Created = "created";
const Ordered = "ordered";
const Paid = "paid";

function all(): string[] {
  return [Created, Ordered, Paid];
}

export default {
  Created,
  Ordered,
  Paid,
  all
};
